import { createAction, props } from '@ngrx/store';
import { DepartmentExtensionInput } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { PresenceContactFilterOptions } from '../models/presence-contact-filter-option';
import { PresenceContactRegisterListItem } from '../models/presence-contact-register-results.model';

const area = 'Presence Contact Register';
export const presenceContactRegisterAdapterActions = createRegisterActions<PresenceContactRegisterListItem>(area);

export const refreshList = createAction(`[${area}] Refresh List`);

export const presenceContactRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: PresenceContactFilterOptions[] }>()
);

export const openDialog = createAction(`[${area}] Open Dialog`, props<{ callDetail: any }>());

export const initiateDirectedCall = createAction(
   `[${area}] Initiate Directed Call`,
   props<{ initiateDirectedCallData: any }>()
);

export const initiateDirectedCallSuccess = createAction(`[${area}] Initiate Directed Call Success`);

export const editPresenceContact = createAction(
   `[${area}] Edit Presence Contact`,
   props<{ presenceContact: PresenceContactRegisterListItem }>()
);

export const editPresenceContactSubmit = createAction(
   '[${area}] Edit Presence Contact Submit',
   props<{
      dndStatus: string;
      office: string;
      extensionPhoneId: number;
      extensionId: number;
      departmentExtensions: DepartmentExtensionInput[];
      fields: string[];
   }>()
);

export const editPresenceContactSuccess = createAction(`[${area}] Edit Presence Contact Success`);

export const editPresenceContactFailure = createAction(
   `[${area}] Edit Presence Contact Failure`,
   props<SingleGraphError>()
);
